// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoPlayerMainContent-cls1_D30","cls2":"VideoPlayerMainContent-cls2_gHg VideoPlayerMainContent-cls1_D30"};